module.exports = __webpack_public_path__ + "img/card_ip_stipulation34.bc5c9e07.svg";